
import { env } from '@env';
import { httpUtil } from '@/framework';
import { GetCustomerReportRequest } from '../Types';
import { GetCustomerOverviewResponse } from './Types';

export const getCustomerReturnOverview = httpUtil.createHttpRequestMeta<
    GetCustomerReportRequest,
    GetCustomerOverviewResponse
>({
    baseUrl: env.orgServer,
    path: '/customers/return-overview',
    method: 'GET',
    authentication: 'bearer'
});
